import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Text } from '@ps-design-system/components/Text';

import PauseToggle from './PauseToggle';
import PauseModalTitle from './PauseModalTitle';

const EndPauseModalPS = ({ isToggled, handleToggle }) => {
  return (
    <div className="end-pause-modal">
      <PauseModalTitle isToggled={isToggled} />
      <div>
        <Text typeface="body-2" >
          <FormattedMessage id="pause.modal.activate_description" defaultMessage="Activating your paused listing will make your listing appear in search and you will be able to receive booking requests and inquiries."/>
        </Text>
      </div>
      <PauseToggle isEndPause toggle={isToggled} onToggle={handleToggle} attributes={{ 'data-testing-id': 'pause-modal-toggle' }} />
    </div>
  );
};

EndPauseModalPS.propTypes = {
  isToggled: PropTypes.bool,
  handleToggle: PropTypes.func
};

EndPauseModalPS.defaultProps = {
  isToggled: false,
  handleToggle: () => {}
};

export default EndPauseModalPS;
